import styled, { ThemeProvider } from 'styled-components';
import { redTheme } from 'src/styles/theme';
import { media } from 'src/styles/designs';
import { ConstraintContainer } from 'src/components/common/ConstraintContainer';
import { Skeleton } from 'src/components/common/Skeleton';
import { Media } from 'vendor/mods/media-breakpoints-fresnel/components/Media';

const Wrapper = styled.header`
  position: relative;
  display: flex;
  align-items: center;
  min-height: 404px;
  background: ${({ theme }) => theme.palette.background};
  ${media.w.greaterThanOrEqual.desktop} {
    min-height: 528px;
    ${ConstraintContainer} {
      max-width: 1100px;
      height: 100%;
    }
  }
`;

const ContentWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding-top: 10px;
  padding-bottom: 30px;
  ${media.w.greaterThanOrEqual.desktop} {
    padding-bottom: 70px;
  }
`;

const ActionsContainer = styled.div`
  display: flex;
  gap: 16px;
  * {
    max-width: 240px;
  }
  ${media.w.lessThan.desktop} {
    flex-direction: column;
    gap: 10px;
  }
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 18px;
  gap: 20px;
  ${media.w.greaterThanOrEqual.desktop} {
    flex-direction: row;
    padding-bottom: 42px;
    align-items: center;
  }
`;

const Details = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const CountdownWrapper = styled.div`
  width: 100%;
  display: flex;
  gap: 12px;
  & > div {
    margin: 0 !important;
  }
  ${media.w.lessThan.desktop} {
    justify-content: flex-end;
    & > div {
      width: 60px;
      height: 60px;
    }
  }
`;

export const EventPageHeaderPlaceholder = () => {
  return (
    <ThemeProvider theme={redTheme}>
      <Wrapper>
        <ConstraintContainer>
          <ContentWrapper>
            <Header>
              <Media greaterThanOrEqual="desktop">
                <Details style={{ marginRight: 30 }}>
                  <Skeleton width={70} height={20} />
                  <Skeleton width={80} height={40} />
                  <Skeleton width={60} height={20} />
                </Details>
              </Media>
              <Details>
                <Skeleton width={140} height={32} />
                <Skeleton width={160} height={32} />
                <Skeleton width={200} height={32} />
              </Details>
            </Header>
            <ActionsContainer>
              <Skeleton width="30vw" height={42} />
              <div>
                <Skeleton width="30vw" height={42} />
              </div>
            </ActionsContainer>
          </ContentWrapper>
          <CountdownWrapper>
            <Skeleton width={80} height={80} />
            <Skeleton width={80} height={80} />
            <Skeleton width={80} height={80} />
          </CountdownWrapper>
        </ConstraintContainer>
      </Wrapper>
    </ThemeProvider>
  );
};
